window.app.controller('rankingCtrl', ['$scope', '$http', '$compile', '$sce', '$document', function ($scope, $sce, $http, $compile, $document) {
  $scope.rankingOffers = [];
  $scope.items = [];
  $scope.goFar = true;
  $scope.scrollLock = false;
  var $window = $(window);
  var counter = 0;
  var responseArticles = 20;
  $scope.moreThanForty = false;

  $scope.getRankingOffers = (responseArticles) => {
    $scope.offersShow = false;
    $scope.sendXHR({
      url: `/rest/catalog/ranking-data` + '?limit=' + responseArticles,
      data: '',
      method: 'GET',
      headers: {'Content-Type': 'application/json'},
      successFunc: function success(resp) {
        $scope.rankingOffers = resp.data;
        $scope.scrollLock = false;
        responseArticles > 40 ? $scope.moreThanForty = true : "";
        for (var i = 0; i < 20; i++) {
          if ($scope.rankingOffers[counter] === undefined) {
            $scope.goFar = false;
            break;
          }
          $scope.items.push($scope.rankingOffers[counter]);
          counter += 1;
        }
        if (counter < 41) $scope.insertBanner();
      }
    });
  };

  $scope.getRankingOffers(responseArticles);

  angular.element(document.querySelector('.main')).bind('scroll', function () {
    var mainContent = ".main__content";
    var height = $(mainContent).offset().top;
    var scrollHeight = $(mainContent).prop('scrollHeight');
    if ($scope.goFar) {
      $scope.$apply();
      if (-height + 1400 >= scrollHeight) {
        $('.ranking .btn-to-top').addClass('visible');
        if ($scope.scrollLock) $window.scrollTop(block);
        $scope.scrollLock = true;
        responseArticles += 20;
        $scope.getRankingOffers(responseArticles);
      }
    }

  });

  $('.ranking .btn-to-top').click('click', () => {
    let headerHeight = $(".header").height();
    $('.ranking-page-scroll').animate({scrollTop: $('.main__content').offset().top - headerHeight}, 1000);
  })

  $scope.manageRankingClass = () => {
    $(".main").addClass("ranking-page-scroll");
  };

  $scope.manageRankingClass();

  $scope.firstBannersInserted = false;

  class rankingBanner {
    constructor(href, src, mobSrc, company, mobHref = null, mobCompany = null) {
      this.href = href;
      this.src = src;
      this.mobSrc = mobSrc;
      this.company = company;
      this.mobHref = mobHref;
      this.mobCompany = mobCompany;
    }

    renderHtml(order) {
      return `<div class="ranking-page__banner layout layout-align-center" style="order: ${order}">
                <a href="${this.href}" target="_blank" class="flex-100" 
                    ga-on="click,auxclick,contextmenu" 
                    ga-event-category="Outclick banner" 
                    ga-event-label="Ranking-offers-banner-${this.company}" 
                >
                    <picture>
                        <source srcset="/front/src/img/${this.src}" media="(min-width: 600px)">
                        <source srcset="/front/src/img/${this.mobSrc}" media="(max-width: 600px)">
                        <img alt="${this.company}" class="" style="width: 100%; height: auto; border-radius: 6px; margin-bottom: -3px;" alt="">
                    </picture>
                </a>
            </div>`
    }

    renderHtmlTwoCompanies(order) {
      return `<div class="ranking-page__banner mob-desc-banners layout layout-align-center" style="order: ${order}">
                <a href="${this.href}" target="_blank" class="flex-100 hide-xs two-comp-desc"
                    ga-on="click,auxclick,contextmenu" 
                    ga-event-category="Outclick banner" 
                    ga-event-label="Ranking-offers-banner-${this.company}" 
                >
                    <img alt="${this.company}" src="/front/src/img/${this.src}" style="width: 100%;">
                </a>
                <a href="${this.mobHref}" target="_blank" class="flex-100 hide-lg hide-md hide-sm two-comp-mob"
                    ga-on="click,auxclick,contextmenu" 
                    ga-event-category="Outclick banner" 
                    ga-event-label="Ranking-offers-banner-${this.mobCompany}" 
                >
                    <img alt="${this.mobCompany}" src="/front/src/img/${this.mobSrc}" style="width: 100%;">
                </a>
            </div>`
    }
  }

  $scope.insertBanner = () => {
    let firstBanner = new rankingBanner('/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c19d7', 'szybka.png', 'szybka_mob.png', "Szybka Gotowka");
    let secondBanner = new rankingBanner('/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c19d3', 'vivus.jpg', 'vivus_mob.png', "Vivus");
    let thirdBanner = new rankingBanner('/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c19e7', 'freezl.png', 'freezl_mob.png', "Freezl");
    let forthBanner = new rankingBanner('https://go.leadgid.ru/aff_c?offer_id=2457&aff_id=25133', '750x200_lendon.jpg', '300x250_halocredit.jpg.png', "Lendon", '/stats/outclick/?offerId=5bf7c0a22a533016276954d9', 'Halocredit');
    let fifthBanner = new rankingBanner('/stats/outclick/?offerId=5c499d9c124f8d41205a4972', 'Bancovo_750x200_.gif', 'Bancovo_300x250.gif', "Bancovo");
    let sixthBanner = new rankingBanner('/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c19fb', 'kassatak.gif', 'kassatak_mob.gif', 'KasaTak');
    let seventhBanner = new rankingBanner('/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c19d2', '750x200_filarum.jpg', 'ekspres_kasa_mob.gif', 'Filarum', '/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c1a15', 'Ekspres Kasa');
    let eigthBanner = new rankingBanner('/stats/outclick/?offerId=5b1f9de8ae0ce8762a5c1a0f', '750x200_minipozyczka.jpg', '300x250_bigcredit.jpg', 'Minipożyczka', '/stats/outclick/?offerId=5c6adaf0124f8d4ae91352d3', 'Bigcredit');
    if (!$scope.firstBannersInserted) {
      $($("#ranking")).append(firstBanner.renderHtml(5));
      $($("#ranking")).append(secondBanner.renderHtml(10));
      $($("#ranking")).append(thirdBanner.renderHtml(15));
      $($("#ranking")).append(forthBanner.renderHtmlTwoCompanies(20));
      $scope.firstBannersInserted = true;
    } else if ($scope.firstBannersInserted) {
      $($("#ranking")).append(fifthBanner.renderHtml(25));
      $($("#ranking")).append(sixthBanner.renderHtml(30));
      $($("#ranking")).append(seventhBanner.renderHtmlTwoCompanies(35));
      $($("#ranking")).append(eigthBanner.renderHtmlTwoCompanies(40));
    }
  }

  // $scope.filtersAsideHeight = () => {
  //     $(window).on('load scroll resize mouseover', function() {
  //         if(window.innerWidth >= 993){
  //             let el = $('.fin-offers'),
  //                 scrollTop = $(this).scrollTop(),
  //                 scrollBot = scrollTop + $(this).height(),
  //                 elTop = el.offset().top,
  //                 elBottom = elTop + el.outerHeight(),
  //                 visibleTop = elTop < scrollTop ? scrollTop : elTop,
  //                 visibleBottom = elBottom > scrollBot ? scrollBot : elBottom,
  //                 height = $('aside').hasClass('sticky') ? visibleBottom - visibleTop - 75 : visibleBottom - visibleTop - 10;
  //             $('.offers-filters--aside').css('height', height+'px')
  //         }
  //     });
  // };

  // $scope.filtersAsideHeight();

}]);



// WEBPACK FOOTER //
// src/js/controllers/offers/finOffers/rankingCtrl.js